import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import vuetify from "./plugins/vuetify";
import initDemoEngine from "@/utils/demoEngine";
import Vuetify from "vuetify/lib";
import store from "./store";
// import colors from "vuetify/lib/util/colors";
import moment from "moment";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.prototype.moment = moment;
initDemoEngine();
window.__ACTIVE_FORM__ = null;
const opts = {
  theme: {
    options: { customProperties: true }
  }
};
Vue.config.errorHandler = function(err, vm, info) {
  console.error(
    "🔥 VUE ERROR:",
    err,
    "\nComponent:",
    vm.$options.name,
    "\nProps:",
    vm.$props,
    "\nData:",
    vm.$data,
    "\nInfo:",
    info
  );

  // If the component rendered an element, show it
  if (vm && vm.$el) {
    console.log("❗ Problematic element HTML:", vm.$el.outerHTML);
  }

  // If the text field has an input element, show it too
  if (vm && vm.$el && vm.$el.querySelector) {
    let input = vm.$el.querySelector("input");
    if (input) {
      console.log("❗ Input element:", input.outerHTML);
      console.log("❗ Input value:", input.value);
    }
  }
};

// Vue.config.errorHandler = (err, vm, info) => {
//   console.group('⚠️ Vue Error Trace');
//   console.error('Message:', err.message);
//   console.error('Component:', vm?.$options?.name || '(anonymous)');
//   console.error('Info:', info);
//   console.error('Props:', vm?.$props);
//   console.error('Data:', vm?.$data);
//   console.error('Stack:', err.stack);
//   console.groupEnd();
// };
// try {
//   const Validatable = require('vuetify/lib/mixins/validatable').default
//   const originalValidate = Validatable.options.methods.validate

//   Validatable.options.methods.validate = function (force, value = this.internalValue) {
//     try {
//       return originalValidate.call(this, force, value)
//     } catch (err) {
//       console.warn(
//         '⚠️ Vuetify validate() failed:',
//         this.$options.name || 'unknown component',
//         'value:',
//         value,
//         err.message
//       )
//       // skip validation rather than crashing app
//       return true
//     }
//   }

//   console.info('✅ Patched Vuetify validatable.validate() with safe try/catch.')
// } catch (e) {
//   console.error('Failed to patch Vuetify validation', e)
// }

const app = new Vue({
  router,
  store,
  vuetify: new Vuetify(opts),
  render: h => h(App)
}).$mount("#app");
console.warn = () => {};
window.__VUE_ROOT__ = app;
window.router = router;
window.__DEMO_GUIDE__ = null;
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", function() {
    navigator.serviceWorker.register("/service-worker.js").then(
      function(registration) {
        console.log("Service Worker registration successful with scope: ", registration.scope);
      },
      function(err) {
        console.log("Service Worker registration failed: ", err);
      }
    );
  });
}
